export default __webpack_public_path__ + "static/media/3184.27713552.png";